import { FAIcon, Theme } from '@nextgen-web-framework/all';
import type { CartNotificationProps } from './types/propsType';
import { CartNotificationTheme } from './types/enums';
import styles from './CartNotification.module.scss';

const iconTheme: { [key: string]: string } = {
  [CartNotificationTheme.GREEN]: Theme.GREEN,
  [CartNotificationTheme.SUCCESS]: Theme.SUCCESS,
  [CartNotificationTheme.PURPLE]: Theme.PURPLE,
  [CartNotificationTheme.RED]: Theme.RED,
  [CartNotificationTheme.YELLOW]: Theme.WARNING,
};

export function CartNotification({
  content,
  subtext,
  onClick,
  textlink,
  clickIcon,
  theme = CartNotificationTheme.PURPLE,
  rightSeperator = false,
  icon,
}: CartNotificationProps) {
  return (
    <div className={`${styles['cart-notification-toast-container']} ${styles[theme]}`}>
      <div className={styles['cart-notification-toast-container-content']}>
        {icon && <FAIcon theme={iconTheme[theme] as Theme.GREEN | Theme.PURPLE} iconName={icon} />}
        <div className={styles['cart-notification-toast-container-content-text']}>
          <span>{content}</span>
          <span className={styles['cart-notification-toast-container-content-sub-text']}>{subtext ?? ''}</span>
        </div>
      </div>
      {rightSeperator && <div className={styles[`${theme}-seperator`]}></div>}
      {textlink && (
        <div
          data-testid="test-undo-button"
          onKeyDown={onClick}
          onClick={onClick}
          tabIndex={0}
          role={'button'}
          className={styles['cart-notification-toast-container-link']}
          aria-label={textlink}
        >
          {textlink}
        </div>
      )}
      {clickIcon && (
        <div
          className={styles['cart-notification-toast-container-click-icon']}
          role="button"
          tabIndex={0}
          onKeyDown={onClick}
          onClick={onClick}
          aria-label={clickIcon}
        >
          <FAIcon iconName={clickIcon} />
        </div>
      )}
    </div>
  );
}
